import { DealerUserFilter } from '../../dealer-users/dealerUserFilter';
import { User } from '../../users/user';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Input } from 'reactstrap';
import { Dropdown } from '@ami/react/core';
import { FilterForm, FilterInputRow, FilterSearchRow } from '@ami/react/core';
import Toggle from 'react-toggle';
import { appConfig } from '@ami/react/core';
import { DealerGroupsAsyncDropdown } from '../../dealer-groups/DealerGroupsAsyncDropdown';
import { DealerBranchesAsyncDropdown } from '../../dealer-branches/DealerBranchesAsyncDropdown';

export default class extends Component {
  static propTypes = {
    filter: PropTypes.instanceOf(DealerUserFilter),
    onChange: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
  };

  state = {
    amiUsers: [],
  };

  async componentDidMount() {
    if (appConfig.isManagementApp) {
      this.loadAmiUsers();
    }
  }

  loadAmiUsers = async () => {
    User.search().then((amiUsers) => {
      this.setState({ amiUsers });
    });
  };

  updateFilter = (filter) =>
    this.props.onChange({ ...this.props.filter, ...filter });

  render() {
    const dealerGroupFilter = appConfig.isManagementApp ? (
      <FilterInputRow label="Dealer Group">
        <DealerGroupsAsyncDropdown
          placeholder="All"
          onChange={(group) =>
            this.updateFilter({
              dealerGroupId: group ? group.id : null,
              dealerGroupName: group ? group.label : null,
              dealerBranchId: null,
            })
          }
          selected={
            this.props.filter.dealerGroupId
              ? {
                  id: this.props.filter.dealerGroupId,
                  label: this.props.filter.dealerGroupName,
                }
              : null
          }
        />
      </FilterInputRow>
    ) : null;
    const otherManagementFilters = appConfig.isManagementApp ? (
      <Fragment>
        <FilterInputRow label="Blackbird Login Status">
          <Dropdown
            placeholder="All"
            items={[
              { id: 1, label: 'Registered' },
              { id: 2, label: 'Invitation Sent, not registered' },
              { id: 3, label: 'No invitation sent' },
            ]}
            selectedId={this.props.filter.registrationStatus}
            onChange={(registrationStatus) =>
              this.updateFilter({ registrationStatus })
            }
            isClearable={true}
          />
        </FilterInputRow>
        <FilterInputRow label="Territory Manager">
          <Dropdown
            placeholder="All"
            items={this.state.amiUsers}
            selectedId={this.props.filter.territoryManagerId}
            onChange={(territoryManagerId) =>
              this.updateFilter({ territoryManagerId })
            }
            isClearable={true}
          />
        </FilterInputRow>
      </Fragment>
    ) : null;
    return (
      <FilterForm onSearch={() => this.props.onFilter()}>
        <FilterInputRow label="Name/Email">
          <Input
            placeholder="Search by name or email"
            value={this.props.filter.search}
            onChange={(e) => this.updateFilter({ search: e.target.value })}
          />
        </FilterInputRow>
        {dealerGroupFilter}
        <FilterInputRow label="Authorized Dealer Branch">
          <DealerBranchesAsyncDropdown
            dealerGroupId={this.props.filter.dealerGroupId}
            onChange={(branch) =>
              this.updateFilter({
                dealerBranchId: branch ? branch.id : null,
                dealerBranchName: branch ? branch.label : null,
              })
            }
            selected={
              this.props.filter.dealerBranchId
                ? {
                    id: this.props.filter.dealerBranchId,
                    label: this.props.filter.dealerBranchName,
                  }
                : null
            }
          />
        </FilterInputRow>
        <FilterInputRow label="Default Dealer Branch">
          <DealerBranchesAsyncDropdown
            dealerGroupId={this.props.filter.dealerGroupId}
            onChange={(branch) =>
              this.updateFilter({
                defaultDealerBranchId: branch ? branch.id : null,
                defaultDealerBranchName: branch ? branch.label : null,
              })
            }
            selected={
              this.props.filter.defaultDealerBranchId
                ? {
                    id: this.props.filter.defaultDealerBranchId,
                    label: this.props.filter.defaultDealerBranchName,
                  }
                : null
            }
          />
        </FilterInputRow>
        {otherManagementFilters}
        <FilterInputRow label="Include Retired?">
          <Toggle
            className="align-middle mb-2"
            checked={this.props.filter.includeRetired}
            onChange={(e) =>
              this.updateFilter({ includeRetired: e.target.checked })
            }
          />
        </FilterInputRow>
        <FilterSearchRow />
      </FilterForm>
    );
  }
}
